/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Ward_TitleInputs */

const vi_report_ward_title = /** @type {(inputs: Report_Ward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doanh thu theo Xã/Phường`)
};

/**

* @param {Report_Ward_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_ward_title = /** @type {((inputs?: Report_Ward_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Ward_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_ward_title(inputs)
});